import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { loadCountry } from '../../store/country/countryActions';
import { loadChangeLogs } from '../../store/changelog/changeLogActions';
import { useSelector, useDispatch } from 'react-redux';
import PublishIcon from '@material-ui/icons/Publish';
import ImportUploadSummary from '../actionmenu/ImportUploadSummary';
import * as TableHeaders from '../util/TableHeaders';
import {
    Paper,
    Typography,
    Box,
    FormControl,
    Select,
    MenuItem,
    Button,
    Grid,
} from '@material-ui/core';
import EventIcon from '@material-ui/icons/Event';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import GetAppIcon from '@material-ui/icons/GetApp';
import { baseUrl, getHolidays } from "../../util/host";
import axios from 'axios';
import { getCurrentUser } from '../../util/host';
import { convertToCSV, formatHolidays } from '../util/csvHelpers';
const countryNameMapping = {
    'SA': 'Saudi Arabia',
    'AE': 'United Arab Emirates',
    'KW': 'Kuwait',
    'BH': 'Bahrain',
    'QA': 'Qatar',
    'OM': 'Oman',
};

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
        backgroundColor: '#f5f5f5',
        minHeight: 'calc(100vh - 64px)',
    },
    uploadSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(3),
      },
      uploadArea: {
        border: '2px dashed #e0e0e0',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(3),
        textAlign: 'center',
        backgroundColor: 'white',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        position: 'relative',
        '&:hover': {
          borderColor: '#3f51b5',
          backgroundColor: '#f8f9fa',
        },
      },
      uploadAreaActive: {
        borderColor: '#3f51b5 !important',
        backgroundColor: '#e8eaf6 !important',
      },
      uploadText: {
        fontSize: '14px',
        color: '#666',
        marginBottom: theme.spacing(2),
      },
      uploadButton: {
        backgroundColor: '#3f51b5',
        color: 'white',
        textTransform: 'none',
        padding: theme.spacing(1.5, 3),
        fontSize: '14px',
        fontWeight: 500,
        '&:hover': {
          backgroundColor: '#303f9f',
        },
        '&:disabled': {
          backgroundColor: '#e0e0e0',
          color: '#9e9e9e',
        },
      },
      hiddenInput: {
        display: 'none',
      },
      fileName: {
        fontSize: '14px',
        color: '#333',
        marginTop: theme.spacing(1),
        fontWeight: 500,
      },
      buttonGroup: {
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'center',
        flexWrap: 'wrap',
      },
    header: {
        marginBottom: theme.spacing(3),
        textAlign: 'left',
    },
    titleContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
    },
    titleIcon: {
        color: '#3f51b5',
        fontSize: 32,
        marginRight: theme.spacing(1),
    },
    title: {
        fontSize: '28px',
        fontWeight: 400,
        color: '#333',
    },
    subtitle: {
        fontSize: '14px',
        color: '#666',
        marginTop: theme.spacing(0.5),
        textAlign: 'left',
    },
    card: {
        padding: theme.spacing(4),
        borderRadius: theme.spacing(1),
        boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
        backgroundColor: 'white',
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    sectionIcon: {
        color: '#3f51b5',
        fontSize: 24,
        marginRight: theme.spacing(1),
    },
    sectionTitle: {
        fontSize: '20px',
        fontWeight: 400,
        color: '#333',
    },
    sectionSubtitle: {
        fontSize: '14px',
        color: '#666',
        marginBottom: theme.spacing(4),
        textAlign: 'left',
    },
    formLabel: {
        fontSize: '14px',
        fontWeight: 500,
        color: '#333',
        marginBottom: theme.spacing(1),
        display: 'block',
        textAlign: 'left',
    },
    formControl: {
        marginBottom: theme.spacing(3),
    },
    select: {
        backgroundColor: '#f5f5f5',
        textAlign: 'left',
        '& .MuiSelect-root': {
            textAlign: 'left',
        },
        '& .MuiOutlinedInput-input': {
            textAlign: 'left',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#e0e0e0',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#bdbdbd',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3f51b5',
        },
    },
    configSection: {
        backgroundColor: '#f8f9fa',
        padding: theme.spacing(3),
        borderRadius: theme.spacing(1),
        marginTop: theme.spacing(3),
        textAlign: 'left',
    },
    configTitle: {
        fontSize: '16px',
        fontWeight: 400,
        color: '#333',
        marginBottom: theme.spacing(2),
    },
    downloadButton: {
        backgroundColor: 'white',
        color: '#333',
        border: '1px solid #e0e0e0',
        textTransform: 'none',
        padding: theme.spacing(1.5, 3),
        fontSize: '14px',
        fontWeight: 500,
        '&:hover': {
            backgroundColor: '#f5f5f5',
            borderColor: '#bdbdbd',
        },
    },
    downloadIcon: {
        marginRight: theme.spacing(1),
    },
}));

const Import = () => {
    const classes = useStyles();
    const [country, setCountry] = useState('');
    const [provinceName, setProvinceName] = useState('');
    const [provinceId, setProvinceId] = useState('');
    const [availableProvinces, setAvailableProvinces] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [dragActive, setDragActive] = useState(false);

    const countryList = useSelector((state) => state.country.countryList);
 
    const hasChanges = useSelector((state) => state.changelog.hasChanges);
    const changeLogs = useSelector((state) => state.changelog.changeLogs);
    const dispatch = useDispatch();
    const getTableHeader = (page) => {
        switch (page) {
          case "province":
            return TableHeaders.ProvinceUploadSummaryTableHeader;
          case "city":
            return TableHeaders.CityUploadSummaryTableHeader;
          case "area":
            return TableHeaders.AreaUploadSummaryTableHeader;
          case "cityarea":
            return TableHeaders.CityAreaUploadSummaryTableHeader;
          default:
            return;
        }
      };
    const [state, setState] = useState({
        openSummaryModal: false,
        uploadSummaryResponse: null,
        page: "",
        isUploading: false,
      });
      const closeUploadSummary = () => {
        setState({
          ...state,
          openSummaryModal: false,
          uploadSummaryResponse: null,
          isUploading: false,
        });
      };
    // File handling functions
    const processFile = (file) => {
        if (file && file.type === 'text/csv') {
            setSelectedFile(file);
           
        } else {
            alert('Please upload a CSV file');
        }
    };

    const handleFileInput = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            processFile(file);
        }
    };

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            processFile(e.dataTransfer.files[0]);
        }
    };

    const handleSubmitUpload = () => {
        const loggedInUser = getCurrentUser();
        const { token,email } = loggedInUser;
        if (selectedFile) {
        
            // Open modal with loading state
            setState({
                ...state,
                openSummaryModal: true,
                uploadSummaryResponse: null,
                page: "cityarea",
                isUploading: true,
            });
            
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('action', 'Update');
            formData.append('country', country);
            formData.append('provinceId', provinceId);
            formData.append('cityAreaExport', 'true');
            formData.append('email', email);
            const warehouse = localStorage.getItem('warehouse');
            if(warehouse) formData.append('warehouse', warehouse);
          
            axios.post(
                `${baseUrl("REACT_APP_API_URL")}/api/address/import/area`,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${token.trim()}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }
            )
            .then((res) => {
              
                let uploadRes = {};
                uploadRes["data"] = res.data.response.data;
                uploadRes["total"] = res.data.response.total;
                uploadRes["failed"] = res.data.response.failed;
                uploadRes["success"] = res.data.response.success;
                // Update modal with upload results only if user hasn't closed it
                setState((prevState) => {
                    // If user closed the modal while uploading, don't reopen it
                    if (!prevState.isUploading) {
                        return prevState;
                    }
                    return {
                        ...prevState,
                        openSummaryModal: true,
                        uploadSummaryResponse: uploadRes,
                        page: "cityarea",
                        isUploading: false,
                    };
                });

                // download the csv file created from res.data
                const headers = [
                  { id: "id", title: "id" },
                  { id: "province", title: "province" },
                  { id: "city", title: "city"},
                  { id: "name_en", title: "area" },
                  { id: "min_sla", title: "min_sla" },
                  { id: "max_sla", title: "max_sla" },
                  { id: "holiday", title: "holiday" },
                  { id: "fast_delivery", title: "fast_delivery" },
                  { id: "fast_delivery_type", title: "fast_delivery_type" },
                  { id: "message", title: "message" }
                ]
                
                convertToCSV(res.data.response.data, headers, "importarea_" + country + "_" + provinceId + ".csv");
                // Reset file after successful upload
                setSelectedFile(null);
                // Reset the file input
                const fileInput = document.getElementById('file-upload');
                if (fileInput) {
                    fileInput.value = '';
                }
            })
            .catch((err) => {
                // Update modal only if user hasn't closed it
                setState((prevState) => {
                    // If user closed the modal while uploading, don't reopen it
                    if (!prevState.isUploading) {
                        return prevState;
                    }
                    return {
                        ...prevState,
                        openSummaryModal: true,
                        uploadSummaryResponse: null,
                        page: "cityarea",
                        isUploading: false,
                    };
                });
                console.error("Upload error:", err);
              //  alert(`Upload failed: ${err.response?.data?.message || err.message}`);
            });
        }
    };
    // Load countries on mount
    useEffect(() => {
        dispatch(loadCountry());
        dispatch(loadChangeLogs());
    }, [dispatch]);

    // Set first country when countryList is loaded
    useEffect(() => {
        if (countryList && countryList.length > 0 && !country) {
            const firstCountry = countryList[0];
            setCountry(firstCountry.title);

            // Set provinces for the first country
            if (firstCountry.province && firstCountry.province.length > 0) {
                setAvailableProvinces(firstCountry.province);
                setProvinceName(firstCountry.province[0].name || firstCountry.province[0].code);
                setProvinceId(firstCountry.province[0].id);
            }
        }
    }, [countryList, country]);

    const handleCountryChange = (event) => {
        const newCountry = event.target.value;
        setCountry(newCountry);
        setProvinceName(''); // Reset province

        // Find the selected country and get its provinces
        const selectedCountry = countryList.find(c => c.title === newCountry);
        if (selectedCountry && selectedCountry.province) {
            setAvailableProvinces(selectedCountry.province);
            // Auto-select first province
            if (selectedCountry.province.length > 0) {
                setProvinceName(selectedCountry.province[0].title || selectedCountry.province[0].code);
                setProvinceId(selectedCountry.province[0].id);
            }
        } else {
            setAvailableProvinces([]);
        }
    };

    const handleProvinceChange = (event) => {
        setProvinceName(event.target.value);
        const provinceId = availableProvinces.find(p => p.name === event.target.value || p.code === event.target.value)?.id;
        setProvinceId(provinceId);
    };

    const handleDownloadTemplate = () => {
        // TODO: Implement download template functionality
       
        const payload = {
            action: 'Update',
            country: country,
            provinceId: provinceId,
            cityId: '',
            areaId: '',
            cityAreaExport: true,
            warehouse: localStorage.getItem("warehouse")
        }
        axios.post(`${baseUrl("REACT_APP_API_URL")}/api/address/get/area/template`, payload)
            .then((res) => {
                const file = res.data;
                const blob = new Blob([file], { type: "text/csv" });
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement("a");
                a.setAttribute("hidden", true);
                a.setAttribute("href", url);
                a.setAttribute("download", "importarea_" + country + "_" + provinceId + ".csv");
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div className={classes.root}>

<ImportUploadSummary
          open={state.openSummaryModal}
          close={closeUploadSummary}
          loading={state.isUploading}
          tabaledata={state.uploadSummaryResponse}
          tableheader={getTableHeader(state.page)}
          holidays={getHolidays()}
        />
            {/* Page Header */}
            <Box className={classes.header}>
                <Box className={classes.titleContainer}>
                    <EventIcon className={classes.titleIcon} />
                    <Typography className={classes.title}>
                        Area-SLA and Holiday
                    </Typography>
                </Box>
                <Typography className={classes.subtitle}>
                    Configure service level agreements and holiday settings by region
                </Typography>
            </Box>

            {/* Main Content Card - Constrained to 8/12 grid */}
            <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                    <Paper className={classes.card}>
                        {/* Section Header */}
                        <Box className={classes.sectionHeader}>
                            <LocationOnIcon className={classes.sectionIcon} />
                            <Typography className={classes.sectionTitle}>
                                Area Selection
                            </Typography>
                        </Box>

                        <Typography className={classes.sectionSubtitle}>
                            Select the country and province to configure area-level settings
                        </Typography>

                        {/* Country Dropdown */}
                        <Box className={classes.formControl}>
                            <Typography className={classes.formLabel}>Country</Typography>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    id="country-select"
                                    value={country}
                                    onChange={handleCountryChange}
                                    className={classes.select}
                                    displayEmpty
                                >
                                    {countryList && countryList.length > 0 ? (
                                        countryList.map((countryItem) => (
                                            <MenuItem key={countryItem.title} value={countryItem.title}>
                                                {countryNameMapping[countryItem.title]}
                                            </MenuItem>
                                        ))
                                    ) : (
                                        <MenuItem value="">
                                            <em>Loading countries...</em>
                                        </MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Box>

                        {/* Province/State Dropdown */}
                        <Box className={classes.formControl}>
                            <Typography className={classes.formLabel}>Province / State</Typography>
                            <FormControl variant="outlined" fullWidth>
                                <Select
                                    id="province-select"
                                    value={provinceName}
                                    onChange={handleProvinceChange}
                                    className={classes.select}
                                    displayEmpty
                                    disabled={!availableProvinces || availableProvinces.length === 0}
                                >
                                    {availableProvinces && availableProvinces.length > 0 ? (
                                        availableProvinces.map((provinceItem) => (
                                            <MenuItem
                                                key={provinceItem.title || provinceItem.code}
                                                value={provinceItem.title || provinceItem.code}
                                            >
                                                {provinceItem.title || provinceItem.code}
                                            </MenuItem>
                                        ))
                                    ) : (
                                        <MenuItem value="">
                                            <em>Select a country first</em>
                                        </MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </Box>

                        {/* Configuration Section */}
                        <Box className={classes.configSection}>
  <Typography className={classes.configTitle}>
    Configuration for <span style={{ fontWeight: 'bold' }}>{provinceName && country ? `${provinceName}, ${countryNameMapping[country]}` : 'Select country and province'}</span>
  </Typography>

  <Box className={classes.uploadSection}>
  <Box 
    className={`${classes.uploadArea} ${dragActive ? classes.uploadAreaActive : ''}`}
    onDragEnter={handleDrag}
    onDragLeave={handleDrag}
    onDragOver={handleDrag}
    onDrop={handleDrop}
  >
    <Typography className={classes.uploadText}>
      {dragActive 
        ? '📁 Drop your CSV file here' 
        : '📤 Drag and drop your CSV file here, or click to browse'
      }
    </Typography>
    
    <input
      type="file"
      accept=".csv"
      onChange={handleFileInput}
      id="file-upload"
      className={classes.hiddenInput}
      disabled={!provinceName || !country}
    />
    
    <label htmlFor="file-upload">
      <Button
        variant="contained"
        component="span"
        className={classes.uploadButton}
        startIcon={<PublishIcon />}
        disabled={!provinceName || !country}
      >
        Choose File
      </Button>
    </label>
    
    {selectedFile && (
      <Typography className={classes.fileName}>
        ✓ Selected: {selectedFile.name}
      </Typography>
    )}
  </Box>

  <Box className={classes.buttonGroup}>
    <Button
      variant="contained"
      className={classes.uploadButton}
      onClick={handleSubmitUpload}
      startIcon={<PublishIcon />}
      disabled={!selectedFile || !provinceName || !country}
    >
      Submit Upload
    </Button>
    
    <Button
      variant="outlined"
      className={classes.downloadButton}
      onClick={handleDownloadTemplate}
      startIcon={<GetAppIcon />}
      disabled={!provinceName || !country}
    >
      Download Template
    </Button>
  </Box>
</Box>
</Box>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    );
};

export default Import;